export * from './delete-kunde.command.module';
export * from './component';
export * from './service';